import { Routes } from '@angular/router';
import { authGuard, guestGuard } from './core/auth/auth.guard';
import { roleGuard } from './core/auth/role.guard';
import { PERMISSIONS } from './core/constants/permissions';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('./features/login/login').then((m) => m.LoginPage),
  },
  {
    path: 'app',
    canActivate: [authGuard],
    loadComponent: () => import('./features/shell/shell').then((m) => m.ShellPage),
    children: [
      {
        path: '',
        loadComponent: () => import('./features/home/home-page').then((m) => m.HomePage),
      },
      {
        path: 'missions',
        loadComponent: () =>
          import('./features/missions/mission-log/mission-log').then((m) => m.MissionLogPage),
      },
      {
        path: 'missions/new',
        loadComponent: () =>
          import('./features/missions/add-mission/add-mission').then((m) => m.AddMissionPage),
      },
      {
        path: 'shift-trade',
        canActivate: [roleGuard],
        data: { privileges: [PERMISSIONS.VIEW_SHIFT_TRADE] },
        loadComponent: () =>
          import('./features/shift-trade/shift-trade').then((m) => m.ShiftTradePage),
      },
    ],
  },
  { path: '', pathMatch: 'full', redirectTo: 'app' },
  { path: '**', redirectTo: 'app' },
];
